export class BifMonitorConstant {
    static readonly bifMonitorAppId: string = "BillIntegrationFrameworkRT";
    static readonly bifManagerAppEntrance: string = "bif-manager";
    
    static readonly bifDiagnostorFuncId: string = "BifDiagnostor";
    static readonly bifManagerFuncId: string = "BifManager";
}

